const mothersDayCardData = {
  link: '/lp-corporate-gifting-website/',
  title: "Mother's Day Hampers",
  name: "Mother's Day Hampers",
  image: {
    sourceUrl:
      'https://cart.gourmetbasket.com.au/wp-content/uploads/2024/04/mothers-day-hamper-scaled.jpg',
    altText: "Mother's Day Hampers",
    sizes: '',
    title: "Mother's Day Hampers",
  },
  id: 34532453434,
};

export default mothersDayCardData;
